var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmailIcon = function SvgEmailIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.3334 13.2834C18.3334 15.6084 16.4667 17.4917 14.1417 17.5001H14.1334H5.87508C3.55841 17.5001 1.66675 15.6251 1.66675 13.3001V13.2917C1.66675 13.2917 1.67175 9.60341 1.67841 7.74841C1.67925 7.40008 2.07925 7.20508 2.35175 7.42175C4.33175 8.99258 7.87258 11.8567 7.91675 11.8942C8.50841 12.3684 9.25841 12.6359 10.0251 12.6359C10.7917 12.6359 11.5417 12.3684 12.1334 11.8851C12.1776 11.8559 15.6392 9.07758 17.6492 7.48091C17.9226 7.26341 18.3242 7.45841 18.3251 7.80591C18.3334 9.64675 18.3334 13.2834 18.3334 13.2834Z",
    fill: "#9595B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8967 4.72784C17.1751 3.36785 15.7551 2.49951 14.1917 2.49951H5.87507C4.31173 2.49951 2.89173 3.36785 2.17007 4.72784C2.0084 5.03201 2.08507 5.41118 2.35423 5.62618L8.54173 10.5753C8.97507 10.9253 9.50007 11.0995 10.0251 11.0995C10.0284 11.0995 10.0309 11.0995 10.0334 11.0995C10.0359 11.0995 10.0392 11.0995 10.0417 11.0995C10.5667 11.0995 11.0917 10.9253 11.5251 10.5753L17.7126 5.62618C17.9817 5.41118 18.0584 5.03201 17.8967 4.72784Z",
    fill: "#9595B1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emailIcon.123ccc86.svg";
export { ForwardRef as ReactComponent };